/// <reference path="./opentype.d.ts" />
/** Fonts: opentype.js for outlines and metrics, plus the analysed glyph centrelines (glyphs.json). */

import { parse, type Font, type Path } from "opentype.js";
import type { PlanStroke } from "./strokes";

export type { Font };

export interface GlyphSet {
  version: number;
  px: number;
  glyphs: Record<string, { strokes: PlanStroke[]; bbox: [number, number, number, number] }>;
}

export interface LoadedFont {
  font: Font;
  glyphs: GlyphSet;
}

export function parseFont(buf: ArrayBuffer): Font {
  return parse(buf);
}

/** opentype.js path → Path2D */
export function toPath2D(p: Path, into: Path2D = new Path2D()): Path2D {
  for (const c of p.commands) {
    switch (c.type) {
      case "M":
        into.moveTo(c.x!, c.y!);
        break;
      case "L":
        into.lineTo(c.x!, c.y!);
        break;
      case "C":
        into.bezierCurveTo(c.x1!, c.y1!, c.x2!, c.y2!, c.x!, c.y!);
        break;
      case "Q":
        into.quadraticCurveTo(c.x1!, c.y1!, c.x!, c.y!);
        break;
      case "Z":
        into.closePath();
        break;
    }
  }
  return into;
}
